window.addEventListener('resize', e => {
	let width = win.getWidth();
	let height = win.getHeight();

	resizeCallbacks.forEach(fn => {
		fn({
			originalEvent: e,
			width,
			height,
			oldWidth: win.width,
			oldHeight: win.height,
		})
	});

	win.width = width;
	win.height = height;
});

window.addEventListener('scroll', e => {
	win.scrollLeft = win.getScrollLeft();
	win.scrollTop = win.getScrollTop();
});

let resizeCallbacks = [];

let win = {
	SM: 576,
	MD: 768,
	BG: 1000,
	LG: 1200,
	XL: 1600,

	width: null,
	height: null,

	scrollLeft: null,
	scrollTop: null,

	getWidth() {
		return document.documentElement.clientWidth;
	},
	getHeight() {
		return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	},
	getScrollLeft() {
		return window.scrollX != null ? window.scrollX : window.pageXOffset;
	},
	getScrollTop() {
		return window.scrollY != null ? window.scrollY : window.pageYOffset;
	},
	onResize(fn) {
		resizeCallbacks.push(fn);
	}
};

win.width = win.getWidth();
win.height = win.getHeight();

win.scrollLeft = win.getScrollLeft();
win.scrollTop = win.getScrollTop();

export default win;